/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

/**
 * Enum to control the method to use for resetting a looping tween.
 */
export enum TWEEN_LOOP {
	'REVERT',
	'REVERSE',
}
